import { render, staticRenderFns } from "./pg_business_medlabo.vue?vue&type=template&id=0633a20b"
import script from "./pg_business_medlabo.vue?vue&type=script&lang=js"
export * from "./pg_business_medlabo.vue?vue&type=script&lang=js"
import style0 from "./pg_business_medlabo.vue?vue&type=style&index=0&id=0633a20b&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports